import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const ScrollSpy = () => {
  useEffect(() => {
    const sections = document.querySelectorAll("section"); // all your <section id="...">
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // update the URL hash without reloading page
            window.history.replaceState(null, null, `#${entry.target.id}`);
          }
        });
      },
      { threshold: 0.6 } // section is considered "active" if 60% visible
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return null; // nothing visible, just logic
};


